import { axiosInstance } from '../instance';

const WorkType = () => {
    return axiosInstance
        .get('/api/work-types');
}

const WorkTypeWithWorkMode = () => {
    return axiosInstance
        .get('/api/work-types-with-work-mode')
}

export { WorkType, WorkTypeWithWorkMode }
